let arrived = false;

/**
 * True for the first page this tab loads in the app, false for every one after.
 * Lets a page tell somebody arriving from somebody already inside, which the
 * router cannot: it calls clicking a nav item "entering" a page as well.
 */
export function takeAppArrival(): boolean {
  const arriving = !arrived;
  arrived = true;
  return arriving;
}
